module.exports = __webpack_public_path__ + "img/token-icon-blue.72443c8b.png";